// extracted by mini-css-extract-plugin
export default {"wrapper":"Settings_wrapper__HMSZb","content":"Settings_content__OXafY","usersList":"Settings_usersList__--NlV"};